import * as THREE from 'three';


export default class ScreenGenerator {

	constructor(currentRoom, scene, whereToAddObjects, configType, configController) {
		this.isAllMeasureDone = false;
		this.currentRoom = currentRoom;
		this.scene = scene;
		this.whereToAddObjects = whereToAddObjects;
		this.configType = configType;
		this.configController = configController;

		this.roomWithDifferentPlacement = ["1", "2", "3"];
		this.roomSansRangeeCentrale = ["4", "8"];
	}

	AddMeasure() {
		var data = [];
		var textToAdd = [];

		switch(this.configType) {
			case "Theatre":
				var pointA = new THREE.Vector3();
				var raycastValue;
				var currentChaises = [];

				for (var i = 0; i < this.whereToAddObjects.children.length; i++) {
					if (this.whereToAddObjects.children[i].name == "Chaise_Bleue") {
						currentChaises.push(this.whereToAddObjects.children[i]);
					}
				}

				currentChaises[0].getWorldPosition(pointA);
				pointA.x -= (0.487 / 2);
				pointA.y = 2;

				raycastValue = this.GetRaycast(pointA, new THREE.Vector3(-1 ,0 ,0));
				data.push({"A":new THREE.Vector3(pointA.x, 5, pointA.z), "B":new THREE.Vector3(raycastValue.point.x, 5, raycastValue.point.z), "dist":raycastValue.distance});

				currentChaises[0].getWorldPosition(pointA);
				pointA.z -= (0.482 / 2);
				pointA.y = 2;

				raycastValue = this.GetRaycast(pointA, new THREE.Vector3(0 ,0 ,-1));
				data.push({"A":new THREE.Vector3(pointA.x, 5, pointA.z), "B":new THREE.Vector3(raycastValue.point.x, 5, raycastValue.point.z), "dist":raycastValue.distance});

				for (var i = currentChaises.length - 1; i >= 0; i--) {
					if (currentChaises[i].visible) {
						currentChaises[i].getWorldPosition(pointA);
						pointA.x += (0.487 / 2);
						pointA.y = 2;

						raycastValue = this.GetRaycast(pointA, new THREE.Vector3(1 ,0 ,0));
						data.push({"A":new THREE.Vector3(pointA.x, 5, pointA.z), "B":new THREE.Vector3(raycastValue.point.x, 5, raycastValue.point.z), "dist":raycastValue.distance});

						//this.CreateTempLine(data[data.length - 1]);

						currentChaises[i].getWorldPosition(pointA);
						pointA.z += (0.482 / 2);
						pointA.y = 2;

						raycastValue = this.GetRaycast(pointA, new THREE.Vector3(0 ,0 ,1));
						data.push({"A":new THREE.Vector3(pointA.x, 5, pointA.z), "B":new THREE.Vector3(raycastValue.point.x, 5, raycastValue.point.z), "dist":raycastValue.distance});
						break;
					}
				}

				var countRange = 0;
				var idChaises = [];
				var basePos = currentChaises[0].position;
				for (var i = 0; i < currentChaises.length ; i++) {
					if ((this.roomWithDifferentPlacement.includes(this.currentRoom)) && basePos.z == currentChaises[i].position.z) {
						countRange++;
						idChaises.push(i);
					}
					else if (!(this.roomWithDifferentPlacement.includes(this.currentRoom)) && basePos.x == currentChaises[i].position.x) {
						countRange++;
						idChaises.push(i);
					}
				}
				if (!(this.roomSansRangeeCentrale.includes(this.currentRoom))) {
					if (countRange%2) {
						currentChaises[idChaises[(countRange - 1)/2]].getWorldPosition(pointA);
						if ((this.roomWithDifferentPlacement.includes(this.currentRoom)))
							pointA.x += (0.487 / 2);
						else
							pointA.z += (0.487 / 2);
						pointA.y = 2;
						var pointB = new THREE.Vector3(); 
						currentChaises[idChaises[((countRange - 1)/2) + 1]].getWorldPosition(pointB);
						if ((this.roomWithDifferentPlacement.includes(this.currentRoom)))
							pointB.x -= (0.487 / 2);
						else
							pointB.z -= (0.487 / 2);
						pointB.y = 2;

						data.push({"A":new THREE.Vector3(pointA.x, 5, pointA.z), "B":new THREE.Vector3(pointB.x, 5, pointB.z), "dist":pointA.distanceTo(pointB)});
					}
					else {
						currentChaises[idChaises[(countRange/2) - 1]].getWorldPosition(pointA);
						if ((this.roomWithDifferentPlacement.includes(this.currentRoom)))
							pointA.x += (0.487 / 2);
						else
							pointA.z += (0.487 / 2);
						pointA.y = 2;
						var pointB = new THREE.Vector3(); 
						currentChaises[idChaises[countRange/2]].getWorldPosition(pointB);
						if ((this.roomWithDifferentPlacement.includes(this.currentRoom)))
							pointB.x -= (0.487 / 2);
						else
							pointB.z -= (0.487 / 2);
						pointB.y = 2;

						data.push({"A":new THREE.Vector3(pointA.x, 5, pointA.z), "B":new THREE.Vector3(pointB.x, 5, pointB.z), "dist":pointA.distanceTo(pointB)});
					}
				}

				var distChaise;
				var distRange;
				distChaise = currentChaises[0].position.distanceTo(currentChaises[1].position);
				distChaise -= 0.487;
				distChaise = (Math.round(distChaise * 1000)/10).toFixed(1);
				distRange = currentChaises[0].position.distanceTo(currentChaises[countRange].position);
				distRange -= 0.487;
				distRange = (Math.round(distRange * 1000)/10).toFixed(1);

				textToAdd.push("Distance entre les chaises : " + distChaise + " cm");
				textToAdd.push("Distance entre les rangees : " + distRange + " cm");
				textToAdd.push("Nombre de chaises : " + this.configController.data.chaiseCount);

				break;
			case "U":
				var pointA = new THREE.Vector3();
				var raycastValue;
				var currentTable = [];

				for (var i = 0; i < this.whereToAddObjects.children.length; i++) {
					if (this.whereToAddObjects.children[i].name == "Table_Reunion" && this.whereToAddObjects.children[i].visible == true) {
						currentTable.push(this.whereToAddObjects.children[i]);
						//this.whereToAddObjects.children[i].visible = true;
					}
				}

				var countBaseU = this.configController.data.nbTableBaseU;
				var idTable = [];
				var basePos = currentTable[0].position;
				if (this.currentRoom == "5" || this.currentRoom == "6" || this.currentRoom == "7" || this.currentRoom == "8") {
					for (var i = 0; i < currentTable.length ; i++) {
						if (Math.round(basePos.x * 1000) == Math.round(currentTable[i].position.x * 1000)) {
							//countRange++;
							idTable.push(i);
						}
					}
				}
				else {
					for (var i = 0; i < currentTable.length ; i++) {
						if (Math.round(basePos.z * 1000) == Math.round(currentTable[i].position.z * 1000)) {
							//countRange++;
							idTable.push(i);
						}
					}
				}

				currentTable[idTable[countBaseU - 1]].getWorldPosition(pointA);
				pointA.y = 2;
				if (this.currentRoom == "5" || this.currentRoom == "6" || this.currentRoom == "7" || this.currentRoom == "8") {
					pointA.x -= (0.7 / 2);
					raycastValue = this.GetRaycast(pointA, new THREE.Vector3(-1 ,0 ,0));
				}
				else {
					pointA.x += (1.4 / 2);
					raycastValue = this.GetRaycast(pointA, new THREE.Vector3(1 ,0 ,0));
				}
				data.push({"A":new THREE.Vector3(pointA.x, 5, pointA.z), "B":new THREE.Vector3(raycastValue.point.x, 5, raycastValue.point.z), "dist":raycastValue.distance});

				currentTable[idTable[countBaseU - 1]].getWorldPosition(pointA);
				pointA.y = 2;
				if (this.currentRoom == "4" || this.currentRoom == "9" || this.currentRoom == "10" || this.currentRoom == "11") {
					pointA.z -= (0.7 / 2);
					raycastValue = this.GetRaycast(pointA, new THREE.Vector3(0 ,0 ,-1));
				}
				else {
					pointA.z += (1.4 / 2);
					raycastValue = this.GetRaycast(pointA, new THREE.Vector3(0 ,0 ,1));
				}
				data.push({"A":new THREE.Vector3(pointA.x, 5, pointA.z), "B":new THREE.Vector3(raycastValue.point.x, 5, raycastValue.point.z), "dist":raycastValue.distance});

				textToAdd.push("Nombre de tables : " + this.configController.data.currentNbTable);
				break;
			case "Classe":
				var pointA = new THREE.Vector3();
				var raycastValue;
				var currentTable = [];

				for (var i = 0; i < this.whereToAddObjects.children.length; i++) {
					if (this.whereToAddObjects.children[i].name == "Table_Reunion" && this.whereToAddObjects.children[i].visible == true) {
						currentTable.push(this.whereToAddObjects.children[i]);
					}
				}

				currentTable[0].getWorldPosition(pointA);
				if (this.currentRoom == "1" || this.currentRoom == "2" || this.currentRoom == "3" || this.currentRoom == "4"
					|| this.currentRoom == "9" || this.currentRoom == "10" || this.currentRoom == "11")
					pointA.x -= (1.4 / 2);
				else 
					pointA.x -= (0.7 / 2);
				pointA.y = 2;

				raycastValue = this.GetRaycast(pointA, new THREE.Vector3(-1 ,0 ,0));
				data.push({"A":new THREE.Vector3(pointA.x, 5, pointA.z), "B":new THREE.Vector3(raycastValue.point.x, 5, raycastValue.point.z), "dist":raycastValue.distance});

				currentTable[0].getWorldPosition(pointA);
				if (this.currentRoom == "1" || this.currentRoom == "2" || this.currentRoom == "3" || this.currentRoom == "4"
					|| this.currentRoom == "9" || this.currentRoom == "10" || this.currentRoom == "11")
					pointA.z -= (0.7 / 2);
				else 
					pointA.z -= (1.4 / 2);
				pointA.y = 2;

				raycastValue = this.GetRaycast(pointA, new THREE.Vector3(0 ,0 ,-1));
				data.push({"A":new THREE.Vector3(pointA.x, 5, pointA.z), "B":new THREE.Vector3(raycastValue.point.x, 5, raycastValue.point.z), "dist":raycastValue.distance});

				for (var i = currentTable.length - 1; i >= 0; i--) {
					if (currentTable[i].visible) {
						currentTable[i].getWorldPosition(pointA);
						if (this.currentRoom == "1" || this.currentRoom == "2" || this.currentRoom == "3" || this.currentRoom == "4"
							|| this.currentRoom == "9" || this.currentRoom == "10" || this.currentRoom == "11")
							pointA.x += (1.4 / 2);
						else 
							pointA.x += (0.7 / 2);
						pointA.y = 2;

						raycastValue = this.GetRaycast(pointA, new THREE.Vector3(1 ,0 ,0));
						data.push({"A":new THREE.Vector3(pointA.x, 5, pointA.z), "B":new THREE.Vector3(raycastValue.point.x, 5, raycastValue.point.z), "dist":raycastValue.distance});

						//this.CreateTempLine(data[data.length - 1]);

						currentTable[i].getWorldPosition(pointA);
						if (this.currentRoom == "1" || this.currentRoom == "2" || this.currentRoom == "3" || this.currentRoom == "4"
							|| this.currentRoom == "9" || this.currentRoom == "10" || this.currentRoom == "11")
							pointA.z += (0.7 / 2);
						else 
							pointA.z += (1.4 / 2);
						pointA.y = 2;

						raycastValue = this.GetRaycast(pointA, new THREE.Vector3(0 ,0 ,1));
						data.push({"A":new THREE.Vector3(pointA.x, 5, pointA.z), "B":new THREE.Vector3(raycastValue.point.x, 5, raycastValue.point.z), "dist":raycastValue.distance});
						break;
					}
				}

				var countRange = 0;
				var basePos = currentTable[0].position;
				for (var i = 0; i < currentTable.length ; i++) {
					if (this.currentRoom == "1" || this.currentRoom == "2" || this.currentRoom == "3" || this.currentRoom == "3"
						|| this.currentRoom == "9" || this.currentRoom == "10" || this.currentRoom == "11") {
						if (basePos.z == currentTable[i].position.z) {
							countRange++;
						}
					}
					else {
						if (basePos.x == currentTable[i].position.x) {
							countRange++;
						}
					}
				}

				var distTable;
				var distRange;
				distTable = currentTable[0].position.distanceTo(currentTable[1].position);
				distTable -= 1.4;
				distTable = (Math.round(distTable * 1000)/10).toFixed(1);
				distRange = currentTable[0].position.distanceTo(currentTable[countRange].position);
				distRange -= 0.7;
				distRange = (Math.round(distRange * 1000)/10).toFixed(1);

				textToAdd.push("Distance entre les tables : " + distTable + " cm");
				textToAdd.push("Distance entre les rangees : " + distRange + " cm");
				textToAdd.push("Nombre de tables : " + this.configController.data.tableCount);
				break;
			case "Travail":
				var pointA = new THREE.Vector3();
				var raycastValue;
				var currentPole = [];

				for (var i = 0; i < this.whereToAddObjects.children.length; i++) {
					if (this.whereToAddObjects.children[i].name == "Pole"  && this.whereToAddObjects.children[i].visible == true) {
						currentPole.push(this.whereToAddObjects.children[i]);
						//this.whereToAddObjects.children[i].visible = true;
					}
				}

				currentPole[0].getWorldPosition(pointA);
				pointA.x -= (1.4 / 2);
				pointA.y = 2;

				raycastValue = this.GetRaycast(pointA, new THREE.Vector3(-1 ,0 ,0));
				data.push({"A":new THREE.Vector3(pointA.x, 5, pointA.z), "B":new THREE.Vector3(raycastValue.point.x, 5, raycastValue.point.z), "dist":raycastValue.distance});

				currentPole[0].getWorldPosition(pointA);
				pointA.z -= (0.7 / 2);
				pointA.y = 2;

				raycastValue = this.GetRaycast(pointA, new THREE.Vector3(0 ,0 ,-1));
				data.push({"A":new THREE.Vector3(pointA.x, 3, pointA.z), "B":new THREE.Vector3(raycastValue.point.x, 5, raycastValue.point.z), "dist":raycastValue.distance});

				for (var i = currentPole.length - 1; i >= 0; i--) {
					if (currentPole[i].visible) {
						currentPole[i].getWorldPosition(pointA);
						pointA.x += (1.4 / 2);
						pointA.y = 2;

						raycastValue = this.GetRaycast(pointA, new THREE.Vector3(1 ,0 ,0));
						data.push({"A":new THREE.Vector3(pointA.x, 5, pointA.z), "B":new THREE.Vector3(raycastValue.point.x, 5, raycastValue.point.z), "dist":raycastValue.distance});

						//this.CreateTempLine(data[data.length - 1]);

						currentPole[i].getWorldPosition(pointA);
						pointA.z += (0.7 / 2) + 0.7;
						pointA.y = 2;

						raycastValue = this.GetRaycast(pointA, new THREE.Vector3(0 ,0 ,1));
						data.push({"A":new THREE.Vector3(pointA.x, 5, pointA.z), "B":new THREE.Vector3(raycastValue.point.x, 5, raycastValue.point.z), "dist":raycastValue.distance});
						break;
					}
				}


				currentPole[0].getWorldPosition(pointA);
				pointA.z += (0.7 / 2) + 0.7;
				pointA.y = 2;
				var pointB = new THREE.Vector3(); 
				currentPole[1].getWorldPosition(pointB);
				pointB.z -= (0.7 / 2);
				pointB.y = 2;
				pointB.x = pointA.x;

				data.push({"A":new THREE.Vector3(pointA.x, 5, pointA.z), "B":new THREE.Vector3(pointB.x, 5, pointB.z), "dist":pointA.distanceTo(pointB)});

				var isFirstCheck = false;
				for (var i = 0; i < currentPole.length ; i++) {
					if (currentPole[0].position.x != currentPole[i].position.x) {
						if (isFirstCheck) {
							currentPole[0].getWorldPosition(pointA);
							pointA.x += (1.4/ 2);
							pointA.y = 2;
							var pointB = new THREE.Vector3(); 
							currentPole[i].getWorldPosition(pointB);
							pointB.x -= (1.4 / 2);
							pointB.y = 2;
							pointA.z = pointB.z;

							data.push({"A":new THREE.Vector3(pointA.x, 5, pointA.z), "B":new THREE.Vector3(pointB.x, 5, pointB.z), "dist":pointA.distanceTo(pointB)});
							break;
						}
						else {
							isFirstCheck = true;
						}
					}
				}

				var distTable;
				distTable = currentPole[0].position.distanceTo(new THREE.Vector3(currentPole[0].position.x, currentPole[1].position.y, currentPole[1].position.z));
				distTable -= 1.4;
				distTable = (Math.round(distTable * 1000)/10).toFixed(1);

				textToAdd.push("Distance entre les poles : " + distTable + " cm");
				textToAdd.push("Nombre de poles : " + this.configController.data.poleCount);
				break;
			case "Ronde":
				var pointA = new THREE.Vector3();
				var raycastValue;
				var currentTable = [];

				for (var i = 0; i < this.whereToAddObjects.children.length; i++) {
					if (this.whereToAddObjects.children[i].name == "Table_Ronde"  && this.whereToAddObjects.children[i].visible == true) {
						currentTable.push(this.whereToAddObjects.children[i]);
						//this.whereToAddObjects.children[i].visible = true;
					}
				}

				currentTable[0].getWorldPosition(pointA);
				pointA.x -= (1.8 / 2);
				pointA.y = 2;

				raycastValue = this.GetRaycast(pointA, new THREE.Vector3(-1 ,0 ,0));
				data.push({"A":new THREE.Vector3(pointA.x, 5, pointA.z), "B":new THREE.Vector3(raycastValue.point.x, 5, raycastValue.point.z), "dist":raycastValue.distance});

				currentTable[0].getWorldPosition(pointA);
				pointA.z -= (1.8 / 2);
				pointA.y = 2;

				raycastValue = this.GetRaycast(pointA, new THREE.Vector3(0 ,0 ,-1));
				data.push({"A":new THREE.Vector3(pointA.x, 5, pointA.z), "B":new THREE.Vector3(raycastValue.point.x, 5, raycastValue.point.z), "dist":raycastValue.distance});

				for (var i = currentTable.length - 1; i >= 0; i--) {
					if (currentTable[i].visible) {
						currentTable[i].getWorldPosition(pointA);
						pointA.x += (1.8 / 2);
						pointA.y = 2;

						raycastValue = this.GetRaycast(pointA, new THREE.Vector3(1 ,0 ,0));
						data.push({"A":new THREE.Vector3(pointA.x, 5, pointA.z), "B":new THREE.Vector3(raycastValue.point.x, 5, raycastValue.point.z), "dist":raycastValue.distance});

						//this.CreateTempLine(data[data.length - 1]);

						currentTable[i].getWorldPosition(pointA);
						pointA.z += (1.8 / 2);
						pointA.y = 2;

						raycastValue = this.GetRaycast(pointA, new THREE.Vector3(0 ,0 ,1));
						data.push({"A":new THREE.Vector3(pointA.x, 5, pointA.z), "B":new THREE.Vector3(raycastValue.point.x, 5, raycastValue.point.z), "dist":raycastValue.distance});
						break;
					}
				}

				currentTable[0].getWorldPosition(pointA);
				pointA.z += (1.8 / 2);
				pointA.y = 2;
				var pointB = new THREE.Vector3(); 
				currentTable[1].getWorldPosition(pointB);
				pointB.z -= (1.8 / 2);
				pointB.y = 2;

				data.push({"A":new THREE.Vector3(pointA.x, 5, pointA.z), "B":new THREE.Vector3(pointA.x, 5, pointB.z), "dist":pointA.distanceTo(pointB)});


				var isFirstCheck = false;
				for (var i = 0; i < currentTable.length ; i++) {
					if (currentTable[0].position.x != currentTable[i].position.x) {
						if (isFirstCheck) {
							currentTable[0].getWorldPosition(pointA);
							pointA.x += (1.8/ 2);
							pointA.y = 2;
							var pointB = new THREE.Vector3(); 
							currentTable[i].getWorldPosition(pointB);
							pointB.x -= (1.8 / 2);
							pointB.y = 2;
							pointA.z = pointB.z;

							data.push({"A":new THREE.Vector3(pointA.x, 5, pointA.z), "B":new THREE.Vector3(pointB.x, 5, pointB.z), "dist":pointA.distanceTo(pointB)});
							break;
						}
						else {
							isFirstCheck = true;
						}
					}
				}


				var distTable;
				distTable = currentTable[0].position.distanceTo(new THREE.Vector3(currentTable[0].position.x, currentTable[1].position.y, currentTable[1].position.z));
				distTable -= 1.8;
				distTable = (Math.round(distTable * 1000)/10).toFixed(1);

				textToAdd.push("Distance entre les tables : " + distTable + " cm");
				textToAdd.push("Nombre de tables : " + this.configController.data.tableCount);
				break;
			case "Cocktail":
				var pointA = new THREE.Vector3();
				var raycastValue;
				var currentTable = [];

				for (var i = 0; i < this.whereToAddObjects.children.length; i++) {
					if (this.whereToAddObjects.children[i].name == "Mange_Debout" && this.whereToAddObjects.children[i].visible == true) {
						currentTable.push(this.whereToAddObjects.children[i]);
						//this.whereToAddObjects.children[i].visible = true;
					}
				}

				currentTable[0].getWorldPosition(pointA);
				pointA.x -= (0.575 / 2);
				pointA.y = 2;

				raycastValue = this.GetRaycast(pointA, new THREE.Vector3(-1 ,0 ,0));
				data.push({"A":new THREE.Vector3(pointA.x, 5, pointA.z), "B":new THREE.Vector3(raycastValue.point.x, 5, raycastValue.point.z), "dist":raycastValue.distance});

				currentTable[0].getWorldPosition(pointA);
				pointA.z -= (0.575 / 2);
				pointA.y = 2;

				raycastValue = this.GetRaycast(pointA, new THREE.Vector3(0 ,0 ,-1));
				data.push({"A":new THREE.Vector3(pointA.x, 5, pointA.z), "B":new THREE.Vector3(raycastValue.point.x, 5, raycastValue.point.z), "dist":raycastValue.distance});

				for (var i = currentTable.length - 1; i >= 0; i--) {
					if (currentTable[i].visible) {
						currentTable[i].getWorldPosition(pointA);
						pointA.x += (0.575 / 2);
						pointA.y = 2;

						raycastValue = this.GetRaycast(pointA, new THREE.Vector3(1 ,0 ,0));
						data.push({"A":new THREE.Vector3(pointA.x, 5, pointA.z), "B":new THREE.Vector3(raycastValue.point.x, 5, raycastValue.point.z), "dist":raycastValue.distance});

						//this.CreateTempLine(data[data.length - 1]);

						currentTable[i].getWorldPosition(pointA);
						pointA.z += (0.575 / 2);
						pointA.y = 2;

						raycastValue = this.GetRaycast(pointA, new THREE.Vector3(0 ,0 ,1));
						data.push({"A":new THREE.Vector3(pointA.x, 5, pointA.z), "B":new THREE.Vector3(raycastValue.point.x, 5, raycastValue.point.z), "dist":raycastValue.distance});
						break;
					}
				}

				currentTable[0].getWorldPosition(pointA);
				pointA.z += (0.575 / 2);
				pointA.y = 2;
				var pointB = new THREE.Vector3(); 
				currentTable[1].getWorldPosition(pointB);
				pointB.z -= (0.575 / 2);
				pointB.y = 2;

				data.push({"A":new THREE.Vector3(pointA.x, 5, pointA.z), "B":new THREE.Vector3(pointA.x, 5, pointB.z), "dist":pointA.distanceTo(pointB)});


				var isFirstCheck = false;
				for (var i = 0; i < currentTable.length ; i++) {
					if (currentTable[0].position.x != currentTable[i].position.x) {
						if (isFirstCheck) {
							currentTable[0].getWorldPosition(pointA);
							pointA.x += (0.575/ 2);
							pointA.y = 2;
							var pointB = new THREE.Vector3(); 
							currentTable[i].getWorldPosition(pointB);
							pointB.x -= (0.575 / 2);
							pointB.y = 2;
							pointA.z = pointB.z;

							data.push({"A":new THREE.Vector3(pointA.x, 5, pointA.z), "B":new THREE.Vector3(pointB.x, 5, pointB.z), "dist":pointA.distanceTo(pointB)});
							break;
						}
						else {
							isFirstCheck = true;
						}
					}
				}


				var distTable;
				distTable = currentTable[0].position.distanceTo(new THREE.Vector3(currentTable[0].position.x, currentTable[1].position.y, currentTable[1].position.z));
				distTable -= 0.575;
				distTable = (Math.round(distTable * 1000)/10).toFixed(1);

				textToAdd.push("Distance entre les tables : " + distTable + " cm");
				textToAdd.push("Nombre de tables : " + this.configController.data.cocktailCount);
				break;
		}

		textToAdd.splice(0, 0, "Salle : " + this.currentRoom);

		for(var i = 0; i < textToAdd.length; i++) {
			data.push({"A":new THREE.Vector3(0, 5, -11.5 + i), "B":new THREE.Vector3(0, 5, -11.5 + i), "text":textToAdd[i]});
		}

		this.CreateTempLine(data, 0);
	}

	GetRaycast(origin, dir) {
		var raycaster = new THREE.Raycaster();
		var intersects;
		var point;

		raycaster.set(origin, dir);
		intersects = raycaster.intersectObjects(this.scene.children, true);
		for (var i = 0; i < intersects.length; i++) {
			if (this.IsParentVisible(intersects[i].object) && !this.IsParentName(intersects[i].object, "Grand_Ecran")) {
				point = intersects[i];
				break;
			}
		}

		return point;
	}

	CreateTempLine(data, index) {
		var geometry = new THREE.BufferGeometry().setFromPoints([data[index].A, data[index].B]);
		var material = new THREE.LineBasicMaterial({ color: 0xff0000 });

		var line = new THREE.Line(geometry, material);
		line.name = "Line";
		this.scene.add(line);
		//var cutIndex = text.indexOf("m");var strResult;
		var strResult;
		if (data[index].dist)
			strResult = ((Math.round(data[index].dist * 1000)/10).toFixed(1)) + "cm";
		else
			strResult = data[index].text;

		const fontLoader = new THREE.FontLoader();
		fontLoader.load('fonts/helvetiker_regular.typeface.json', function (font) {
			const textGeometry = new THREE.TextGeometry(strResult, {
				font: font,
				size: 0.5, // Taille du texte
				height: 0.01, // Hauteur du texte
				curveSegments: 12, // Nombre de segments de courbe pour la géométrie
				bevelEnabled: false // Activation de l'effet de chanfrein
			});

			// Création du matériau pour le texte
			const material = new THREE.MeshBasicMaterial({ color: 0xff0000 });

			// Création de l'objet texte
			const textMesh = new THREE.Mesh(textGeometry, material);

			const boundingBox = new THREE.Box3();
			boundingBox.setFromObject(textMesh);

			// Obtenir les dimensions de la boîte englobante (largeur, hauteur, profondeur)
			const size = new THREE.Vector3();
			boundingBox.getSize(size);

			const centerPoint = new THREE.Vector3();
			centerPoint.lerpVectors(data[index].A, data[index].B, 0.5);

			textMesh.position.set(centerPoint.x, centerPoint.y, centerPoint.z);
			textMesh.rotation.x = -Math.PI/2;
			
			textMesh.translateY(0.1);

			textMesh.name = "Text";

			this.scene.add(textMesh);
			if (data.length - 1 > index) {
				index++;
				this.CreateTempLine(data, index);
			}
			else {
				this.isAllMeasureDone = true;
			}
		}.bind(this));
	}

	ClearTempLines() {
		for(var i = this.scene.children.length - 1; i >= 0 ; i--) {
			if (this.scene.children[i].name == "Line" || this.scene.children[i].name == "Text") {
				this.scene.remove(this.scene.children[i]);
			}
		}
	}

	IsParentVisible(object) {
		if (object.visible) {
			if (object.parent) {
				return this.IsParentVisible(object.parent);
			}
			else {
				return true;
			}
		}
		else {
			return false;
		}
	}

	IsParentName(object, nametoCheck) {
		if (object.name == nametoCheck) {
			return true;
		}
		else {
			if (object.parent) {
				return this.IsParentName(object.parent, nametoCheck);
			}
			else {
				return false;
			}
		}
	}
}